import WebComponent from "./_web_component";

export default class WCUpdInput extends WebComponent {
	constructor(el, params) {
		super(el, params)
	}

	init(){
		const {
			elValCalc,
			operator
		} = this.params

		$(this.element).on('keyup', (e) => {
			let val = $(e.target).val()
			val = val ? parseFloat(val):0;
			const valCalc = $(elValCalc).data('vrliq') ? parseFloat($(elValCalc).data('vrliq')):0

			let valTotal = 0
			switch(operator){
				case '-':
					valTotal = valCalc - val;
					break;

				case '*':
				case 'x':
					valTotal = valCalc * val;
					break;

				case '+':
				default:
					valTotal = valCalc + val;
					break;
			}

			$(elValCalc).val(valTotal);
		})
	}
}
